import { ChevronRightGray400Icon } from '@assets/iconComponents';
import { Frame, ImageListItemComponent, ImageModal, MenuTop, Text } from '@components';
import { useUsedImageList } from '@hooks';
import { colorSet } from '@theme';
import { IImageListItem } from '@types';

const UsedImageListPage = () => {
  const {
    handleBreadCrumbClick,
    data,
    flattenUsedImageList,
    outputBottomRef,
    handleImageClick,
    handleImageModalClose,
    handleImageUseButtonClick
  } = useUsedImageList();

  const gap = 4;
  const itemNumberPerRow = 7;
  const sumOfHorizontalGaps = gap * (itemNumberPerRow - 1);
  const itemSize = `calc((100% - ${sumOfHorizontalGaps}px) / ${itemNumberPerRow})`;

  return (
    <>
      <MenuTop />

      <Frame width="100%" padding="24px 40px 96px 40px">
        <div style={{ marginBottom: '20px' }}>
          <div
            onClick={handleBreadCrumbClick}
            style={{
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center',
              marginBottom: '4px',
              cursor: 'pointer'
            }}
          >
            <Text variant="body1" color="primary" marginRight="10px">
              컬렉션
            </Text>
            <ChevronRightGray400Icon style={{ width: 16, height: 16 }} />
          </div>
          <Text variant="h2" fontWeight="bold">
            사용한 이미지
          </Text>
        </div>

        <div
          style={{
            display: 'flex',
            flexWrap: 'wrap',
            gap: `${gap}px`,
            width: '100%',
            boxSizing: 'border-box'
          }}
        >
          {data &&
            flattenUsedImageList().length > 0 &&
            flattenUsedImageList().map((item: IImageListItem, index) => {
              return (
                <ImageListItemComponent
                  key={`${item.id}_${index}`}
                  item={item}
                  itemSize={itemSize}
                  onImageClick={handleImageClick}
                  onUseButtonClick={handleImageUseButtonClick}
                />
              );
            })}
        </div>
        <div ref={outputBottomRef} />

        {(!data || flattenUsedImageList().length === 0) && (
          <div
            style={{
              height: '100px',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center'
            }}
          >
            <Text variant="body1" color={colorSet.gray500}>
              저장한 이미지가 없습니다.
            </Text>
          </div>
        )}
      </Frame>

      <ImageModal onClose={handleImageModalClose} onUseButtonClick={handleImageUseButtonClick} />
    </>
  );
};

export default UsedImageListPage;
